import { usePodcastsLibraryBase } from './library-base';
import { usePodcastPageBase } from './usePodcastPageBase';

export const usePodcastWebPage = (id) => {
   const library = usePodcastsLibraryBase();
   const base = usePodcastPageBase(id,library.isAuthenticated)
   return {...base, ...library }
}